import sherlocked from "../../assets/lightbox/cases/sherlocked.webp";
import whiteLotus from "../../assets/lightbox/cases/white-lotus.webp";
import weekendAtBernies from "../../assets/lightbox/cases/weekend-at-bernies.webp";

/* UI-DESIGN: LB-8 local case art, LB-13 as warm colour slides. The API's
   cover URLs are example.com seeds, so the three live cases get slides
   shipped with the app (generated in FLORA), matched by case name. Any
   other case gets the blank warm transparency in CaseSlide. When the API carries real covers, those win (see toCaseView).
   LB-30 (2026-10-03, Taco picked D): each slide is graded as film and
   cropped tight on the case's clue, the moment the margin note rings
   (slideNotes.ts). Interim art: the crops come from the earlier 1200px
   frames and are due to be replaced with full-resolution case images.
   LB-36 eval (2026-10-04): trying "pulp on glass": mid-century gouache
   printed as a backlit transparency (FLORA round 4, 43-45), film border
   cropped off so the mount is the only frame. 3:2 like the window.
   Darker pass (round 5, 46-48): about two stops down for the lit table.
   LB-36 final (2026-10-04): the locked 46-48 upscaled to 2496px, shipped
   at 1600px WebP q80 (the slide window is ~1475px on the 2048 texture),
   same compositions, so the pencil rings in slideNotes.ts still land.
   LB-49 (2026-10-04): the same three, with small details hidden for the
   magnifier (FLORA i2i edits of the locked art, upscaled to 2496px; listed
   in docs/lightbox/lb43-46/COPY.md as invented for review). Same 1600px
   WebP q80: under the loupe the art shows at ~0.43 of the source on a
   1440 screen, below what the 1600px file carries, so a larger file would
   not read any sharper there. */
const ART_BY_KEY: Record<string, string> = {
  sherlocked,
  whitelotus: whiteLotus,
  weekendatbernies: weekendAtBernies,
};

const keyOf = (name: string) => name.toLowerCase().replace(/[^a-z0-9]/g, "");

/* UI-DESIGN: 2026-10-25 the art ships with the app, so the Home can start
   downloading it before the case list arrives from the API */
export const SHIPPED_ART = Object.values(ART_BY_KEY);

export const caseArtFor = (name: string | undefined): string | null =>
  (name && ART_BY_KEY[keyOf(name)]) || null;
